module.exports = __webpack_public_path__ + "img/imagealt.be78b7a1.png";